import { render, staticRenderFns } from "./ConfirmModuleDeleteModal.vue?vue&type=template&id=b42a14d0&scoped=true&"
import script from "./ConfirmModuleDeleteModal.vue?vue&type=script&lang=ts&"
export * from "./ConfirmModuleDeleteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42a14d0",
  null
  
)

export default component.exports